import { ApiClient } from "../../api/ApiClient";

const apiBaseUrl = process.env.REACT_APP_API_DOMAIN;

export const createConnectedAccount = async (url) => {
  const csrfToken = await ApiClient.getCsrfToken();
  const response = fetch(`${apiBaseUrl}/${url}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-CSRFToken": csrfToken,
    },
    credentials: "include",
  });

  return response;
};

export const getStripeConnectedAccount = async (url) => {
  const csrfToken = await ApiClient.getCsrfToken();
  const response = fetch(`${apiBaseUrl}/${url}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      "X-CSRFToken": csrfToken,
    },
    credentials: "include",
  });

  return response;
};
